import { addStripe } from '@client/new/api/stripe.api';
import { useUser } from '@client/new/hooks/use-user';
import { navigate, PATHS } from '@client/routes';
import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

export const StripeCallbackPage: React.FC = () => {
  const { refetchInfluencer } = useUser();
  const stripeConnectCode = new URLSearchParams(window.location.search).get(
    'code',
  );

  useEffect(() => {
    if (stripeConnectCode) {
      addStripe(stripeConnectCode)
        .then(() => toast.success('Connected Stripe successfully'))
        .then(() => refetchInfluencer())
        .catch(() => toast.error('Failed to connect Stripe'))
        .finally(() => navigate(PATHS.HOME));
    }
  }, [stripeConnectCode]);

  return 'Loading...';
};
